const PETALS = [0, 72, 144, 216, 288];

export function Flower({ x = 0, y = 0, s = 1, fill = "#f7f2e8", center = "#c3a572", rot = 0, opacity = 1 }) {
  return (
    <g transform={`translate(${x} ${y}) rotate(${rot}) scale(${s})`} opacity={opacity}>
      {PETALS.map((a) => (
        <ellipse
          key={a}
          cx="0"
          cy="-5.4"
          rx="3.1"
          ry="5"
          fill={fill}
          stroke="rgba(195,165,114,.55)"
          strokeWidth="0.5"
          transform={`rotate(${a})`}
        />
      ))}
      <circle r="1.9" fill={center} />
    </g>
  );
}

export function LeafShape({ fill, vein }) {
  return (
    <>
      <path d="M0 0 C 34 -26, 92 -30, 138 -8 C 96 18, 36 20, 0 0 Z" fill={fill} />
      <path d="M4 0 C 46 -12, 96 -16, 132 -9" fill="none" stroke={vein} strokeWidth="1" opacity="0.7" />
      <path
        d="M30 -7 L 38 -17 M 52 -11 L 60 -21 M 76 -13 L 84 -22 M 100 -12 L 106 -19"
        stroke={vein}
        strokeWidth="0.7"
        opacity="0.5"
        fill="none"
      />
    </>
  );
}

function RoseShape({ s = 1 }) {
  return (
    <g transform={`scale(${s})`}>
      {PETALS.map((a) => (
        <ellipse
          key={a}
          cx="0"
          cy="-14"
          rx="8"
          ry="13"
          fill="#d9a3a3"
          stroke="rgba(120,66,72,.35)"
          strokeWidth="0.8"
          transform={`rotate(${a})`}
        />
      ))}
      <circle r="8.5" fill="#c98b92" />
      <circle r="4.6" fill="#b97b84" />
      <circle cx="1" cy="-1" r="2" fill="#8f5a64" opacity="0.8" />
    </g>
  );
}

export function FoliageCluster({ width = 300, className, style, flip = false, leavesOnly = false }) {
  return (
    <svg
      viewBox="0 0 300 240"
      width={width}
      fill="none"
      className={className}
      style={{ transform: flip ? "scaleX(-1)" : undefined, ...style }}
      aria-hidden="true"
    >
      <g transform="translate(8,6) rotate(80) scale(1.3)">
        <LeafShape fill="#8a9168" vein="rgba(70,76,52,.6)" />
      </g>
      <g transform="translate(8,6) rotate(30) scale(1.5)">
        <LeafShape fill="#7d8461" vein="rgba(56,62,42,.6)" />
      </g>
      <g transform="translate(8,6) rotate(56) scale(1.18)">
        <LeafShape fill="#6d7455" vein="rgba(50,56,38,.6)" />
      </g>
      <g transform="translate(8,6) rotate(12) scale(1.12)">
        <LeafShape fill="#98a073" vein="rgba(70,76,52,.55)" />
      </g>
      <g transform="translate(8,6) rotate(44) scale(0.9)">
        <LeafShape fill="#a7ac7f" vein="rgba(78,84,58,.5)" />
      </g>
      {!leavesOnly && (
        <>
          <g transform="translate(190,116)">
            <RoseShape s={1.15} />
          </g>
          <g transform="translate(126,168)">
            <RoseShape s={0.82} />
          </g>
          <path d="M152 150 C 172 184, 202 200, 236 208" stroke="#b08d4f" strokeWidth="1" opacity="0.8" />
          <path d="M168 176 c 5 -3 8 1 5 5 c -3 4 -8 0 -5 -5 Z" fill="#d5a3a0" />
          <path d="M196 194 c 5 -3 8 1 5 5 c -3 4 -8 0 -5 -5 Z" fill="#c98f94" />
          <circle cx="222" cy="205" r="3.4" fill="#d5a3a0" />
          <path d="M214 128 q 12 30 -4 56" stroke="#c3a572" strokeWidth="0.9" opacity="0.75" />
          <path d="M214 138 c 4 -2 5 2 3 4 c -2 2 -6 -1 -3 -4 Z" fill="#faf6ec" />
          <path d="M212 156 c 4 -2 5 2 3 4 c -2 2 -6 -1 -3 -4 Z" fill="#faf6ec" />
          <path d="M211 172 c 4 -2 5 2 3 4 c -2 2 -6 -1 -3 -4 Z" fill="#faf6ec" />
        </>
      )}
    </svg>
  );
}

export function JasmineGarland({ rows = 8, width = 46, className, style, delay = 0, dur = 7 }) {
  const step = 22;
  const H = 24 + rows * step + 18;
  return (
    <div
      className={`garland ${className || ""}`}
      style={{ ...style, animationDelay: `${delay}s`, animationDuration: `${dur}s` }}
      aria-hidden="true"
    >
      <svg viewBox={`0 0 48 ${H}`} width={width} fill="none">
        <line x1="24" y1="0" x2="24" y2={H - 16} stroke="#a5854e" strokeWidth="1.5" opacity="0.9" />
        {Array.from({ length: rows }).map((_, i) => {
          const y = 16 + i * step;
          return i % 3 === 2 ? (
            <g key={i} transform={`translate(24 ${y})`}>
              <circle r="3.2" fill="#c3a572" stroke="rgba(120,90,50,.5)" strokeWidth="0.7" />
            </g>
          ) : (
            <g key={i} transform={`translate(24 ${y}) scale(1.3)`}>
              <path
                d="M0 -7 C 6 -3, 6 4, 0 7 C -6 4, -6 -3, 0 -7 Z"
                fill="#fbf7ee"
                stroke="rgba(140,105,60,.75)"
                strokeWidth="0.9"
              />
              <circle cy="-1" r="1.4" fill="#b08d4f" />
            </g>
          );
        })}
        <circle cx="24" cy={H - 13} r="4" fill="#b08d4f" stroke="rgba(120,90,50,.5)" strokeWidth="0.7" />
        <circle cx="24" cy={H - 8} r="2.6" fill="#c3a572" />
      </svg>
    </div>
  );
}

export function ChainDiya({ links = 8, width = 42, className, style, delay = 0, dur = 6.4 }) {
  const B = links * 14;
  const H = B + 58;
  return (
    <div
      className={`diya ${className || ""}`}
      style={{ ...style, animationDelay: `${delay}s`, animationDuration: `${dur}s` }}
      aria-hidden="true"
    >
      <svg viewBox={`0 0 60 ${H}`} width={width} fill="none">
        {Array.from({ length: links }).map((_, i) => (
          <ellipse
            key={i}
            cx="30"
            cy={10 + i * 14}
            rx="3.1"
            ry="6"
            stroke="#b08d4f"
            strokeWidth="1.2"
            opacity="0.9"
          />
        ))}
        <circle cx="30" cy={B + 12} r="4" fill="#c3a572" stroke="#8a6a3a" strokeWidth="0.8" />
        <circle cx="30" cy={B + 34} r="13" fill="#c3a572" opacity="0.14" />
        <path
          className="diya-flame"
          d={`M30 ${B + 22} C 34.4 ${B + 27} 34.4 ${B + 32.5} 30 ${B + 35} C 25.6 ${B + 32.5} 25.6 ${B + 27} 30 ${B + 22} Z`}
          fill="#dcc9a0"
        />
        <path
          d={`M12 ${B + 39} Q 30 ${B + 35} 48 ${B + 39} Q 46 ${B + 51} 30 ${B + 53} Q 14 ${B + 51} 12 ${B + 39} Z`}
          fill="#521e2b"
          stroke="#c3a572"
          strokeWidth="1.1"
        />
        <path
          d={`M12 ${B + 39} Q 30 ${B + 43} 48 ${B + 39}`}
          stroke="#c3a572"
          strokeWidth="0.8"
          opacity="0.7"
        />
      </svg>
    </div>
  );
}

const ART_PETALS = [0, 60, 120, 180, 240, 300];

export function FloralLineArt({ width = 200, tone = "#c3a572", className, style }) {
  return (
    <svg viewBox="0 0 220 220" width={width} fill="none" className={className} style={style} aria-hidden="true">
      <path d="M18 214 C 44 164, 62 126, 96 66" stroke={tone} strokeWidth="1.2" opacity="0.85" />
      <g transform="translate(50 152) rotate(-18)">
        <path d="M0 0 C 14 -11, 30 -13, 42 -6 C 28 4, 12 5, 0 0 Z" stroke={tone} strokeWidth="1" opacity="0.8" />
      </g>
      <g transform="translate(66 118) rotate(24)">
        <path d="M0 0 C 13 -10, 28 -12, 38 -5 C 26 4, 10 4, 0 0 Z" stroke={tone} strokeWidth="1" opacity="0.8" />
      </g>
      <g transform="translate(34 188) rotate(40)">
        <path d="M0 0 C 12 -9, 26 -11, 35 -4 C 24 3, 9 4, 0 0 Z" stroke={tone} strokeWidth="1" opacity="0.75" />
      </g>
      <g transform="translate(122 44)">
        {ART_PETALS.map((a) => (
          <ellipse
            key={a}
            cx="0"
            cy="-15"
            rx="8.5"
            ry="15"
            stroke={tone}
            strokeWidth="1"
            opacity="0.9"
            transform={`rotate(${a})`}
          />
        ))}
        <circle r="7" stroke={tone} strokeWidth="1" opacity="0.9" />
        <circle r="2" fill={tone} opacity="0.9" />
      </g>
      <g transform="translate(84 92)">
        <path d="M0 0 C 7 -7, 15 -6, 16 2 C 10 8, 2 7, 0 0 Z" stroke={tone} strokeWidth="1" opacity="0.85" />
        <path d="M2 6 C 1 12, -2 16, -6 18" stroke={tone} strokeWidth="0.9" opacity="0.75" />
      </g>
      <path d="M18 214 C 10 196, 16 178, 30 172" stroke={tone} strokeWidth="0.9" opacity="0.6" />
    </svg>
  );
}

export function JasmineStrand({ width = 240, className, style }) {
  const flowers = [
    { x: 26, y: 34, s: 0.9, r: 20 },
    { x: 62, y: 62, s: 1.05, r: -10 },
    { x: 102, y: 78, s: 0.85, r: 30 },
    { x: 142, y: 80, s: 1, r: 0 },
    { x: 180, y: 68, s: 0.9, r: -25 },
    { x: 210, y: 50, s: 0.8, r: 15 },
  ];
  const d = "M2 8 C 60 100, 150 104, 230 44";
  return (
    <svg viewBox="0 0 232 120" width={width} fill="none" className={className} style={style} aria-hidden="true">
      <path d={d} stroke="#c3a572" strokeWidth="1" opacity="0.7" />
      <path d={d} stroke="#c3a572" strokeWidth="3" opacity="0.12" />
      {flowers.map((f, i) => (
        <Flower key={i} {...f} />
      ))}
      <circle cx="44" cy="52" r="2.4" fill="#f7f2e8" />
      <circle cx="84" cy="74" r="2.2" fill="#f7f2e8" />
      <circle cx="122" cy="84" r="2.4" fill="#f7f2e8" />
      <circle cx="162" cy="78" r="2.2" fill="#f7f2e8" />
      <ellipse cx="70" cy="66" rx="4.5" ry="1.8" fill="rgba(195,165,114,.45)" transform="rotate(-32 70 66)" />
      <ellipse cx="130" cy="90" rx="4.5" ry="1.8" fill="rgba(195,165,114,.45)" transform="rotate(-12 130 90)" />
      <ellipse cx="188" cy="64" rx="4.5" ry="1.8" fill="rgba(195,165,114,.45)" transform="rotate(-40 188 64)" />
    </svg>
  );
}

export function Diya({ width = 54, className, style, delay = 0, dur = 5.5 }) {
  return (
    <div
      className={`diya ${className || ""}`}
      style={{ ...style, animationDelay: `${delay}s`, animationDuration: `${dur}s` }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 60 112" width={width} fill="none">
        <line x1="30" y1="0" x2="30" y2="52" stroke="#c3a572" strokeWidth="1" opacity="0.8" />
        <circle cx="30" cy="55" r="2.6" stroke="#c3a572" strokeWidth="1" />
        <circle cx="30" cy="66" r="14" fill="#c3a572" opacity="0.14" />
        <path
          className="diya-flame"
          d="M30 57 C34.4 62 34.4 67.5 30 70 C25.6 67.5 25.6 62 30 57 Z"
          fill="#dcc9a0"
        />
        <path
          className="diya-flame"
          d="M30 61.5 C31.8 63.5 31.8 66 30 67.5 C28.2 66 28.2 63.5 30 61.5 Z"
          fill="#8a6a3a"
        />
        <path
          d="M12 74 Q30 70 48 74 Q46 86 30 88 Q14 86 12 74 Z"
          fill="#521e2b"
          stroke="#c3a572"
          strokeWidth="1.1"
        />
        <path d="M12 74 Q30 78 48 74" stroke="#c3a572" strokeWidth="0.8" opacity="0.7" />
        <line x1="24" y1="88" x2="36" y2="88" stroke="#c3a572" strokeWidth="1" opacity="0.7" />
      </svg>
    </div>
  );
}

export function VineBranch({ width = 190, className, style, flip = false }) {
  return (
    <svg
      viewBox="0 0 200 84"
      width={width}
      fill="none"
      className={className}
      style={{ transform: flip ? "scaleX(-1)" : undefined, ...style }}
      aria-hidden="true"
    >
      <path d="M4 74 C 52 28, 118 66, 196 12" stroke="#c3a572" strokeWidth="1.1" opacity="0.55" />
      <ellipse cx="42" cy="52" rx="6" ry="2.2" fill="rgba(195,165,114,.4)" transform="rotate(-38 42 52)" />
      <ellipse cx="74" cy="46" rx="6" ry="2.2" fill="rgba(195,165,114,.4)" transform="rotate(-14 74 46)" />
      <ellipse cx="108" cy="52" rx="6" ry="2.2" fill="rgba(195,165,114,.4)" transform="rotate(-20 108 52)" />
      <ellipse cx="142" cy="44" rx="6" ry="2.2" fill="rgba(195,165,114,.4)" transform="rotate(-32 142 44)" />
      <ellipse cx="170" cy="30" rx="6" ry="2.2" fill="rgba(195,165,114,.4)" transform="rotate(-38 170 30)" />
      <circle cx="60" cy="42" r="2" fill="#f7f2e8" />
      <circle cx="126" cy="50" r="2" fill="#f7f2e8" />
      <Flower x={196} y={12} s={0.75} />
    </svg>
  );
}

export function PalaceArch({ width = 130, className, style }) {
  return (
    <svg viewBox="0 0 120 92" width={width} fill="none" className={className} style={style} aria-hidden="true">
      <path d="M10 90 V48 C10 24 34 24 60 6 C86 24 110 24 110 48 V90" stroke="#c3a572" strokeWidth="1.3" />
      <path
        d="M16 90 V50 C16 30 36 30 60 14 C84 30 104 30 104 50 V90"
        stroke="#c3a572"
        strokeWidth="0.7"
        opacity="0.5"
      />
      <circle cx="60" cy="6" r="2.2" fill="#c3a572" />
    </svg>
  );
}

export function CornerFlourish({ size = 76, className, style, leafFill = "rgba(195,165,114,.4)" }) {
  return (
    <svg viewBox="0 0 80 80" width={size} height={size} fill="none" className={className} style={style} aria-hidden="true">
      <path d="M1 1 H40" stroke="#c3a572" strokeWidth="1" opacity="0.8" />
      <path d="M1 1 V40" stroke="#c3a572" strokeWidth="1" opacity="0.8" />
      <path d="M1 7 H30" stroke="#c3a572" strokeWidth="0.6" opacity="0.45" />
      <path d="M7 1 V30" stroke="#c3a572" strokeWidth="0.6" opacity="0.45" />
      <Flower x={8} y={8} s={0.62} />
      <ellipse cx="24" cy="7" rx="4" ry="1.6" fill={leafFill} transform="rotate(180 24 7)" />
      <ellipse cx="7" cy="24" rx="4" ry="1.6" fill={leafFill} transform="rotate(90 7 24)" />
    </svg>
  );
}

export function FloralDivider({ width = 220, tone = "#c3a572", flowerFill = "#f7f2e8", className, style }) {
  return (
    <svg viewBox="0 0 220 24" width={width} fill="none" className={className} style={style} aria-hidden="true">
      <line x1="0" y1="12" x2="82" y2="12" stroke={tone} strokeWidth="0.8" opacity="0.7" />
      <line x1="138" y1="12" x2="220" y2="12" stroke={tone} strokeWidth="0.8" opacity="0.7" />
      <path d="M92 12 L97 7 L102 12 L97 17 Z" stroke={tone} strokeWidth="0.8" opacity="0.8" />
      <path d="M118 12 L123 7 L128 12 L123 17 Z" stroke={tone} strokeWidth="0.8" opacity="0.8" />
      <Flower x={110} y={12} s={0.8} fill={flowerFill} center={tone} />
    </svg>
  );
}

export function BloomPair({ width = 110, className, style }) {
  return (
    <svg viewBox="0 0 110 24" width={width} fill="none" className={className} style={style} aria-hidden="true">
      <line x1="0" y1="12" x2="36" y2="12" stroke="#a5854e" strokeWidth="0.8" opacity="0.7" />
      <line x1="74" y1="12" x2="110" y2="12" stroke="#a5854e" strokeWidth="0.8" opacity="0.7" />
      <Flower x={55} y={12} s={0.9} fill="#e9d3b8" center="#a5854e" />
      <circle cx="42" cy="12" r="1.6" fill="#a5854e" />
      <circle cx="68" cy="12" r="1.6" fill="#a5854e" />
    </svg>
  );
}

export function TempleBell({ width = 44, tone = "#c3a572", className, style, delay = 0, dur = 6 }) {
  return (
    <div
      className={`bell ${className || ""}`}
      style={{ ...style, animationDelay: `${delay}s`, animationDuration: `${dur}s` }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 60 120" width={width} fill="none">
        {[0, 1, 2].map((i) => (
          <ellipse key={i} cx="30" cy={8 + i * 13} rx="3" ry="5.6" stroke={tone} strokeWidth="1.1" opacity="0.9" />
        ))}
        <path d="M30 46 c 2 -5 8 -5 10 0" stroke={tone} strokeWidth="1" />
        <path
          d="M30 50 C 14 52 12 70 12 80 L 48 80 C 48 70 46 52 30 50 Z"
          stroke={tone}
          strokeWidth="1.5"
          fill="rgba(195,165,114,.08)"
        />
        <path d="M9 84 H51" stroke={tone} strokeWidth="1.5" />
        <path d="M12 80 L9 84 M48 80 L51 84" stroke={tone} strokeWidth="1.2" />
        <circle cx="30" cy="93" r="4.2" fill={tone} opacity="0.9" />
        <path d="M30 84 V89" stroke={tone} strokeWidth="1" />
        <path d="M22 62 q 8 4 16 0" stroke={tone} strokeWidth="0.7" opacity="0.6" />
      </svg>
    </div>
  );
}

export function Toran({ width = 380, tone = "#c3a572", className, style }) {
  const drops = [28, 76, 124, 172, 220, 268, 316];
  return (
    <svg viewBox="0 0 344 84" width={width} fill="none" className={className} style={style} aria-hidden="true">
      <path d="M0 6 Q 172 34 344 6" stroke={tone} strokeWidth="1.2" opacity="0.85" />
      <path d="M0 10 Q 172 40 344 10" stroke={tone} strokeWidth="0.6" opacity="0.4" />
      {drops.map((x, i) => {
        const sag = 1 - Math.abs(x - 172) / 172;
        const y = 8 + sag * 24;
        return i % 2 === 0 ? (
          <g key={x} transform={`translate(${x} ${y})`}>
            <line x1="0" y1="0" x2="0" y2="10" stroke={tone} strokeWidth="0.8" />
            <path
              d="M0 10 C 7 16 7 28 0 36 C -7 28 -7 16 0 10 Z"
              stroke={tone}
              strokeWidth="1.1"
              fill="rgba(138,145,104,.14)"
            />
            <path d="M0 13 V32" stroke={tone} strokeWidth="0.6" opacity="0.6" />
          </g>
        ) : (
          <g key={x} transform={`translate(${x} ${y})`}>
            <line x1="0" y1="0" x2="0" y2="8" stroke={tone} strokeWidth="0.8" />
            <Flower x={0} y={16} s={0.85} center={tone} />
          </g>
        );
      })}
    </svg>
  );
}
